"use client";

import { BridgeStatusUpdater } from "./app/equityModal/BridgeStatusUpdater";
import { PortfolioUpdater } from "./app/portfolio/PortfolioUpdater";
import { ComboUpdater } from "./combo/ComboUpdater";
import { OptionsUpdater } from "./options/OptionsUpdater";
import { RfqUpdater } from "./rfq/RfqUpdater";
import { AccountUpdater } from "./wallet/AccountUpdater";
import { AuthRefreshUpdater } from "./wallet/AuthRefreshUpdater";
import { ReferralUpdater } from "./wallet/ReferralUpdater";
import { WalletLockUpdater } from "./wallet/WalletLockUpdater";

export function StoreUpdaters() {
  ComboUpdater();
  AccountUpdater();
  OptionsUpdater();
  ReferralUpdater();
  PortfolioUpdater();
  WalletLockUpdater();
  ReferralUpdater();
  RfqUpdater();
  AuthRefreshUpdater();

  return <BridgeStatusUpdater />;
}
